import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withUser } from '../contexts/user';
import { withConditionsData } from '../contexts/conditionsData';

import CTAGetStarted from '../components/cta/GetStarted';

import Content from './condition/Content';
import Photos from './condition/Photos';

class Condition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: undefined,
      condition: undefined,
      fromConditionResults: props.location.state ? props.location.state.fromConditionResults : false
    };
  }

  componentDidMount() {
    this.loadCondition(this.props.match.params.id);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.loadCondition(props.match.params.id);
  }

  async loadCondition(id) {
    const { conditionsData, history } = this.props;

    // Loading conditions data from S3 if not yet loaded
    if (!conditionsData.conditions) {
      await conditionsData.loadConditions();
    }

    const condition = conditionsData.conditions.find((c) => c.id === id);

    if (condition) {
      this.setState({ id, condition });
    } else {
      history.replace('/health');
    }
  }

  render() {
    const { id, condition, fromConditionResults } = this.state;
    const { history, match, user } = this.props;

    if (!condition) { return null; }

    const contentProps = { id, condition, history, location, fromConditionResults };
    const photosProps = { condition, history };

    return (
      <div className="condition-view">
        <Switch>
          <Route exact path="/health/conditions/:id" render={() => <Content {...contentProps} />} />
          <Route exact path="/health/conditions/:id/photos" render={() => <Photos {...photosProps} />} />

          <Route exact path={`${match.path}/*`} component={() => (
            <Redirect to={match.url} />
          )} />
        </Switch>

        { !user.isClinician &&
          <CTAGetStarted />
        }
      </div>
    );
  }
}

Condition.defaultProps = {};

Condition.propTypes = {
  match: PropTypes.object.isRequired,
  conditionsData: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default withUser(withConditionsData(Condition));
